export const COMPANY = {
  name: "Fratelli D'Ambrosio",
  legalName: "Fratelli D'Ambrosio S.R.L.",
  tagline: "Esperienza e passione per costruire il futuro",
  description:
    "Da oltre mezzo secolo operiamo nel settore delle costruzioni. Un'eredità familiare tramandata di generazione in generazione, oggi solida struttura organizzativa al servizio del territorio.",
  founded: "1970",
  experience: "50+",
  email: "info@fratellidambrosio.it",
  phone: "015 247 7195",
  phoneRaw: "+390152477195",
  address: "Via F. Rosazza, 4 — 13816 Sagliano Micca (BI)",
  hours: "Lun – Ven · 08:00 – 12:00 / 14:00 – 16:00",
  instagram: "https://www.instagram.com/impresadambrosiosrl",
  instagramHandle: "@impresadambrosiosrl",
  // Dati legali
  vat: "00238870026",
  cf: "00238870026",
  rea: "BI-107574",
  capital: "€ 100.000,00 i.v.",
  pec: "fratellidambrosiosrl.bi00@infopec.cassaedile.it",
  legalAddress: "Via F. Rosazza, 4 — 13816 Sagliano Micca (BI)",
  // Coordinate per mappa (Sagliano Micca, BI)
  mapLat: 45.5816,
  mapLng: 8.0411,
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_impresa-dambrosio/artifacts/lgd3kvy1_IMG_6624.png";

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_impresa-dambrosio/artifacts/rnlzrkd9_ce65afab-170a-4c6a-979d-071b85c129cb.jpeg";

export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_impresa-dambrosio/artifacts/btnuxktm_c537fc29-4cba-4177-a0ca-fa4f18e89365.jpeg";

export const SERVICES = [
  {
    slug: "stradale",
    number: "01",
    title: "Settore Stradale",
    short: "Costruzione, risanamento e manutenzione delle infrastrutture viarie.",
    image:
      "https://customer-assets.emergentagent.com/job_impresa-dambrosio/artifacts/ag9murye_98d1b8a8-0380-4c74-969d-3e58f1981288.jpeg",
    description:
      "Realizziamo opere stradali complete: fondazioni, pavimentazioni in conglomerato bituminoso, cordoli, marciapiedi e segnaletica. Interveniamo su strade comunali, provinciali e private garantendo tempi rapidi e standard qualitativi elevati.",
    offerings: [
      "Pavimentazioni in asfalto e conglomerato bituminoso",
      "Risanamento del corpo stradale",
      "Cordoli, marciapiedi e caditoie",
      "Segnaletica e guardrail",
      "Manutenzione ordinaria e straordinaria",
    ],
  },
  {
    slug: "civile",
    number: "02",
    title: "Settore Civile",
    short: "Ingegneria naturalistica: palificate, gabbionate e consolidamento del territorio.",
    image:
      "https://customer-assets.emergentagent.com/job_impresa-dambrosio/artifacts/oja4z4m6_71f10b82-79f3-4485-b28d-11bed9e2b3a7.jpeg",
    description:
      "Il nostro settore civile è dedicato all'ingegneria naturalistica: interventi a basso impatto ambientale per la protezione del territorio e il consolidamento dei versanti. Tecniche tradizionali e moderne unite per ripristinare la stabilità dei luoghi nel rispetto del paesaggio.",
    offerings: [
      "Palificate in legname",
      "Gabbionate e terre rinforzate",
      "Muri in pietra a secco",
      "Consolidamento versanti e scarpate",
      "Opere di ripristino e bonifica ambientale",
    ],
  },
  {
    slug: "specialistici",
    number: "03",
    title: "Settori Specialistici",
    short: "Micropali, opere strutturali, opere idrauliche e di difesa del territorio.",
    image:
      "https://customer-assets.emergentagent.com/job_impresa-dambrosio/artifacts/btnuxktm_c537fc29-4cba-4177-a0ca-fa4f18e89365.jpeg",
    description:
      "Interventi complessi che richiedono competenze tecniche specifiche: micropali e fondazioni speciali, opere strutturali in cemento armato, opere idrauliche e di difesa del suolo. Sono gli ambiti che approfondiamo con particolare cura, supportati da un parco mezzi dedicato.",
    offerings: [
      "Micropali e fondazioni speciali",
      "Sottomurazioni e consolidamenti strutturali",
      "Opere strutturali in cemento armato",
      "Opere idrauliche e regimazione delle acque",
      "Reti fognarie, acquedotti e difesa del suolo",
    ],
  },
  {
    slug: "sgombero-neve",
    number: "04",
    title: "Sgombero Neve",
    short: "Servizio invernale di sgombero neve e spargimento sale su strade e piazzali.",
    image:
      "https://customer-assets.emergentagent.com/job_impresa-dambrosio/artifacts/5oyktsjo_c61682e9-21b9-46f4-b43c-0836d6327d75.jpeg",
    description:
      "Servizio invernale attivo 24/7 durante la stagione fredda. Disponibilità di mezzi sgombraneve, spazzaneve e spargisale per garantire la viabilità di strade comunali, provinciali e aree private anche nelle condizioni più critiche.",
    offerings: [
      "Sgombero neve su strade pubbliche e private",
      "Spargimento sale e inerti antighiaccio",
      "Reperibilità 24/7 nella stagione invernale",
      "Mezzi sgombraneve e spazzaneve dedicati",
      "Pulizia piazzali, parcheggi e aree industriali",
    ],
  },
];

export const EXPERTISE = [
  {
    icon: "Droplets",
    title: "Opere Idrauliche",
    desc: "Regimazione delle acque, opere fognarie, acquedotti e interventi di difesa del suolo.",
  },
  {
    icon: "Mountain",
    title: "Consolidamento Versanti",
    desc: "Stabilizzazione di pendii e scarpate con interventi mirati e duraturi nel tempo.",
  },
  {
    icon: "Anchor",
    title: "Opere Strutturali",
    desc: "Micropali, fondazioni speciali, sottomurazioni e strutture in cemento armato.",
  },
  {
    icon: "Construction",
    title: "Opere Stradali",
    desc: "Pavimentazioni, risanamento corpo stradale, cordoli e segnaletica.",
  },
  {
    icon: "TreePine",
    title: "Ingegneria Naturalistica",
    desc: "Palificate in legname, gabbionate e tecniche a basso impatto ambientale.",
  },
  {
    icon: "Truck",
    title: "Vasto Parco Mezzi",
    desc: "Macchinari e attrezzature dedicati: pronti per ogni tipologia di cantiere.",
    highlight: true,
  },
];

export const CERTIFICATIONS = [
  {
    code: "SOA",
    title: "Attestazione SOA",
    description:
      "Qualificazione per la partecipazione alle gare di appalto per l'esecuzione di lavori pubblici.",
  },
  {
    code: "ISO 9001",
    title: "Sistema Qualità",
    description:
      "Certificazione che attesta la qualità dei processi aziendali e l'orientamento al miglioramento continuo.",
  },
  {
    code: "DURC",
    title: "Regolarità Contributiva",
    description:
      "Documento unico di regolarità contributiva in corso di validità per tutti i lavori pubblici e privati.",
  },
  {
    code: "D.Lgs. 81/08",
    title: "Sicurezza sul Lavoro",
    description:
      "Piena conformità alle normative di sicurezza sul lavoro con personale formato e aggiornato.",
  },
];

export const PORTFOLIO = [
  {
    id: "p1",
    title: "Riqualificazione Via Provinciale",
    category: "Stradale",
    year: "2024",
    image:
      "https://images.unsplash.com/photo-1772852311587-329719989e2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxyb2FkJTIwY29uc3RydWN0aW9uJTIwYXNwaGFsdCUyMHdvcmtlcnxlbnwwfHx8fDE3Nzc3NDkyNzZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p2",
    title: "Edificio Residenziale Multipiano",
    category: "Civile",
    year: "2023",
    image:
      "https://images.unsplash.com/photo-1716037999044-98a8e85dfa1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjaXZpbCUyMGFyY2hpdGVjdHVyZSUyMGJ1aWxkaW5nJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3Nzc0OTI3Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p3",
    title: "Rete Fognaria Comunale",
    category: "Specialistici",
    year: "2023",
    image:
      "https://images.unsplash.com/photo-1759745125627-333e78bc1edc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxoZWF2eSUyMGV4Y2F2YXRvciUyMG1hY2hpbmVyeSUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3Nzc3NDkyNzZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p4",
    title: "Consolidamento Pendio Naturalistico",
    category: "Specialistici",
    year: "2022",
    image:
      "https://images.unsplash.com/photo-1649034872337-feaa751786ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxoZWF2eSUyMGV4Y2F2YXRvciUyMG1hY2hpbmVyeSUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3Nzc3NDkyNzZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p5",
    title: "Ristrutturazione Edificio Storico",
    category: "Civile",
    year: "2022",
    image:
      "https://images.unsplash.com/photo-1556894769-b9a5dab851c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjaXZpbCUyMGFyY2hpdGVjdHVyZSUyMGJ1aWxkaW5nJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3Nzc0OTI3Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "p6",
    title: "Manutenzione Invernale Rete Viaria",
    category: "Stradale",
    year: "2024",
    image:
      "https://images.unsplash.com/photo-1772852311587-329719989e2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxyb2FkJTIwY29uc3RydWN0aW9uJTIwYXNwaGFsdCUyMHdvcmtlcnxlbnwwfHx8fDE3Nzc3NDkyNzZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const STATS = [
  { value: "50+", label: "Anni di esperienza" },
  { value: "300+", label: "Cantieri completati" },
  { value: "40+", label: "Mezzi specializzati" },
  { value: "ISO 9001", label: "Certificazione qualità" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/azienda", label: "Azienda" },
  { to: "/servizi", label: "Servizi" },
  { to: "/certificazioni", label: "Certificazioni" },
  { to: "/portfolio", label: "Lavori" },
  { to: "/contatti", label: "Contatti" },
];
